import styled from 'styled-components'
import { BREAKPOINTS, RESERVATION_BOOKING_MODAL_MOBILE_BREAKPOINT_INT } from '../../styles/constants'
import ErrorScreen from '../../atoms/ErrorScreen/ErrorScreen'
import { RESERVATION_BOOKING_MODAL_Z_INDEXES } from './reservationBookingModalHelpers'

const NOTINO_MODAL_DESKTOP_MARGIN = 5 // in rem
// we need to add 1px while overriding styles because Notino components use max-width instead of min-widths
const BREAKPOINT = `${RESERVATION_BOOKING_MODAL_MOBILE_BREAKPOINT_INT + 1}px`

// NOTE: we need to override styles on Notino modal for which no better approach was found.
// Selector depth includes the ModalContainer from atoms/Modal.
export const ModalWrapper = styled.div`
	z-index: ${RESERVATION_BOOKING_MODAL_Z_INDEXES.MODAL_WRAP};
	position: relative;
	> div > div > div {
		overflow-y: auto;

		> div[role='dialog']:first-of-type {
			position: relative;
			max-width: 100vw;

			> div:first-of-type {
				height: 100%;
				max-height: initial;
				overflow: hidden;

				@media (min-width: ${BREAKPOINTS.lg}) {
					max-height: 720px;
					height: 100%;
				}

				> div:first-of-type {
					height: 100%;
					> div:first-of-type {
						height: 100%;
					}
				}
			}

			@media (min-width: ${BREAKPOINT}) and (max-width: ${BREAKPOINTS.lg}) {
				max-width: 500px;
				min-height: 400px;
				margin: ${NOTINO_MODAL_DESKTOP_MARGIN}rem auto;
				height: calc(100% - ${NOTINO_MODAL_DESKTOP_MARGIN * 2}rem);
				border-radius: 4px;
				overflow: hidden;
			}

			@media (min-width: ${BREAKPOINTS.lg}) {
				max-width: fit-content;
				border-radius: 4px;
				overflow: hidden;
				height: calc(100% - ${NOTINO_MODAL_DESKTOP_MARGIN * 2}rem);
				max-height: 720px;
				min-height: 400px;
			}

			@media (min-width: ${BREAKPOINT}) and (max-height: ${BREAKPOINTS.md}) {
				margin: ${NOTINO_MODAL_DESKTOP_MARGIN / 2}rem auto;
				height: calc(100% - ${NOTINO_MODAL_DESKTOP_MARGIN}rem);
			}
		}
	}
`

export const Content = styled.div`
	height: 100%;
`

export const StyledError = styled(ErrorScreen)`
	height: 100%;
`
